import styled from 'styled-components';
import { fromMd, timingDefault, timingSlower, withHoverSupport, zIndexForeground, } from '../../constants';
import { verticalRhythm } from '../../lib/utils';
import { TypeStyle } from '../TypeStyle';
const lineHeight = 1.5;
const maxNumberOfLines = 2;
export const Container = styled.div ``;
export const Link = styled.a `
  position: relative;
`;
export const MediaContainer = styled.div `
  position: relative;
`;
export const BadgeContainer = styled.div `
  position: absolute;
  z-index: ${zIndexForeground};
  top: ${o => o.theme.spacing(2.5)};
  left: ${o => o.theme.spacing(1.25)};
`;
export const ImageContainer = styled.div `
  aspect-ratio: 3 / 4;
`;
export const PrimaryImageContainer = styled(ImageContainer) `
  background: white;
  height: 100%;
  opacity: 1;
  position: relative;
  transition: opacity ${timingSlower} ease;
  width: 100%;
  z-index: ${zIndexForeground};
  aspect-ratio: 3 / 4;

  /* Only enable primary + secondary image switching on devices that support hover */
  ${withHoverSupport} {
    &:hover {
      opacity: ${o => o.hideOnHover && '0'};
    }
  }
`;
export const SecondaryImageContainer = styled.div `
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
export const OverlineText = styled(TypeStyle.HeadlineMicro) `
  margin-top: ${o => o.theme.spacing(2)};
  color: ${o => o.color ?? o.theme.color.deprecated.info};
  font-size: ${o => o.theme.spacing(2.25)};

  ${fromMd} {
    font-size: ${o => o.theme.spacing(2.75)};
  }
`;
export const Title = styled(TypeStyle.HeadlineExtraExtraSmall) `
  max-height: ${lineHeight * maxNumberOfLines}em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${maxNumberOfLines};
  -webkit-box-orient: vertical;
  margin-top: ${o => o.theme.spacing(4)};
  /* Only allow underline-on-hover if the current device supports hover */
  ${withHoverSupport} {
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const Unavailable = styled.div `
  align-items: center;
  background-color: ${o => o.theme.color.deprecated.stoneLighter};
  display: flex;
  height: 100%;
  font-size: ${o => o.theme.spacing(3.25)};
  font-weight: ${o => o.theme.typography.deprecated.font.weight.normal};
  justify-content: center;
  letter-spacing: 0.05em;
  opacity: ${o => (o.show ? 0.8 : 0)};
  pointer-events: none;
  position: absolute;
  text-transform: uppercase;
  top: 0;
  transition: opacity ${timingDefault} ease;
  width: 100%;
  z-index: ${zIndexForeground};

  ${fromMd} {
    font-size: ${o => o.theme.spacing(3.75)};
  }
`;
export const DetailsContainer = styled.div `
  margin-top: ${o => o.theme.spacing(2)};
  ${o => verticalRhythm(o.theme.spacing(2))};
`;
export const DetailLine = styled(TypeStyle.BodyNano) `
  color: ${o => o.theme.color.deprecated.obsidianLight};

  ${fromMd} {
    font-size: ${o => o.theme.spacing(3.25)};
  }
`;
//# sourceMappingURL=styles.js.map